import { pushDataLayerEvent } from '@/shared/libs/analytics/gtm';

export const DIALOG_ITEM_ATTRIBUTE = 'data-item';

let started = false;
let attributeObserver: MutationObserver;

const lastFired = new WeakMap<Element, string>();

const reportIfChanged = (element: Element) => {
  const itemName = element.getAttribute(DIALOG_ITEM_ATTRIBUTE);
  if (!itemName) return;
  if (lastFired.get(element) === itemName) return;

  lastFired.set(element, itemName);
  pushDataLayerEvent({ event: 'view_popup', popup_name: itemName });
};

const trackElement = (element: Element) => {
  reportIfChanged(element);
  attributeObserver.observe(element, {
    attributes: true,
    attributeFilter: [DIALOG_ITEM_ATTRIBUTE],
  });
};

const scanForDialogs = (root: Element) => {
  if (root.hasAttribute(DIALOG_ITEM_ATTRIBUTE)) {
    trackElement(root);
  }
  root.querySelectorAll(`[${DIALOG_ITEM_ATTRIBUTE}]`).forEach(trackElement);
};

export const startDialogViewObserver = () => {
  if (started || typeof window === 'undefined') return;
  started = true;

  attributeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => reportIfChanged(mutation.target as Element));
  });

  scanForDialogs(document.body);

  const insertionObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        scanForDialogs(node as Element);
      });
    });
  });

  insertionObserver.observe(document.body, { childList: true });
};
